export default async function useConfirmDialog (message) {
  // REASON: Intended use of confirm
  // eslint-disable-next-line no-alert
  return confirm(message)
}
